import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtDateTime, relDate } from "@/lib/crm";
import { AlertTriangle, ArrowUpRight } from "lucide-react";

// Avviso admin (solo monitoraggio): sorgenti Google Sheets ATTIVE con problemi di sincronizzazione
export default function SyncAlertBanner() {
  const navigate = useNavigate();
  const [problems, setProblems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/sources/sync-health").then((r) => setProblems(
      (r.data.sources || []).filter((s) => s.active && s.type === "google_sheets" && (s.health === "warning" || s.health === "error"))
    )).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (problems.length === 0) return null;
  return (
    <div className="rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm" data-testid="dashboard-sync-alert">
      <div className="flex items-center gap-2 font-semibold text-red-700 dark:text-red-400">
        <AlertTriangle className="w-4 h-4" /> Problemi di sincronizzazione Google Sheets
        <button onClick={() => navigate("/impostazioni")} className="ml-auto text-xs font-medium inline-flex items-center gap-1 hover:underline" data-testid="dashboard-sync-alert-open">
          Dettagli <ArrowUpRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <ul className="mt-1.5 space-y-0.5">
        {problems.map((s) => (
          <li key={s.id} data-testid={`dashboard-sync-alert-${s.id}`} className="text-red-700/90 dark:text-red-300/90">
            <b>{s.name}</b> · ultima sincronizzazione riuscita: {s.last_success_at ? `${fmtDateTime(s.last_success_at)} (${relDate(s.last_success_at)})` : "mai"}
            {s.consecutive_errors > 0 ? ` · ${s.consecutive_errors} errori consecutivi` : ""}{s.stuck_lock ? " · sincronizzazione interrotta, riprende al prossimo ciclo" : ""}
          </li>
        ))}
      </ul>
    </div>
  );
}
